import { render, staticRenderFns } from "./error-bar.vue?vue&type=template&id=5d907038&scoped=true&"
import script from "./error-bar.vue?vue&type=script&lang=js&"
export * from "./error-bar.vue?vue&type=script&lang=js&"
import style0 from "./error-bar.vue?vue&type=style&index=0&id=5d907038&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d907038",
  null
  
)

export default component.exports